import {translation} from "@2d-front-monorepo/core";
import {EntityDocumentation, IAttachments} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, memo, FC} from "react";

export type AttachmentsComponentProps = {
	entity: IAttachments;
	linkPrefix: string;
	className: string;
}

function AttachmentsComponent({entity, linkPrefix, className}: AttachmentsComponentProps): JSX.Element {
	if (entity.attachments.length === 0) {
		return <></>;
	}

	return <dl className={"title-desc " + className}>
		<dt>{translation(PermitTranslations.documentation)}</dt>
		<dd><EntityDocumentation linkPrefix={linkPrefix} entity={entity}/></dd>
	</dl>;
}

const MemoizedAttachmentsComponent: FC<AttachmentsComponentProps> = memo(AttachmentsComponent);
export default MemoizedAttachmentsComponent;
